// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__OLOJD","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__liyph"};